// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
  Table
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';

import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { orderStatus } from '../../../redux/actions/frontActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';

import {renderAlert,clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from "react-number-format";
import Cookies from 'universal-cookie';

import languageConfig from "../../../config/languageConfig";

const cookies = new Cookies();

const history = createBrowserHistory();
let cart='';
class OrderStatus extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context){
    super(props, context);
    this.state = {
      email: '',
      orderID: '',
      showAlert: false,
      disabled:false,
      orderList: '',
      hover: false,
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en')
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({ disabled: false });
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };


  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear(){
    this.setState({
      email: '',
      orderID: '',
    });
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }

    if(siteData){
      this.setState({ fontFamilies: siteData.font_families });
    }

    if(siteData){
      this.setState({twitterPage: siteData.twitterPage,facebookPage: siteData.facebookPage, siteName: siteData.siteName, youtube_link: siteData.youtube_link, insta_link: siteData.insta_link});
      let showCityPasswordFrom = true 
      if(siteData.password_protect == 'active' && this.props.match.path != '/login' && this.props.match.path != '/register/') {
        const cityPasswordIndx = siteData.city_passwords.findIndex(x => x.cityID === siteData.default_city);
        const cityIndx = accessibleCities.findIndex(x => x.cityID === siteData.default_city);
        
        if((cityIndx >= 0 && accessibleCities[cityIndx].status == true) || cityPasswordIndx == -1 ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
          
    }

    if(this.props.themeData){
      this.setState({
        themeData: this.props.themeData
      });

      if(this.props.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(this.props.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : this.props.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }
  }


  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }

    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.language){
      if(this.state.default_lang !== nextProps.language){
        this.setState({default_lang: nextProps.language});
      }
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if(this.props.ordertracking != nextProps.ordertracking){
      console.log(nextProps.ordertracking);
    	if(nextProps.ordertracking){
    		this.setState({orderList: nextProps.ordertracking});
    		this.setState({disabled:false})
    	}
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
         this.setState({showAlert:true})
        this.handleShow();
        this.props.renderAlert('warning', nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if(this.props.message !== nextProps.message){
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
        //Clear();
    }

    

  }

  componentWillUpdate(nextProps, nextState){
  }

  validate = () => { 
    let isError = false;
    const errors = {};

    if(!this.state.orderID){
      isError = true;
      this.setState({orderIDError:"red"})
    }

    if(!this.state.email){
      isError = true;
      this.setState({emailError:"red"})
    }else if(this.state.email){
      if(this.getValidationEmailState()){
       isError = true;
       this.setState({emailError:"red"})
      }
    }

    return isError;
  }

  getValidationEmailState() {
    if(this.state.email){
      const length = this.state.email.length;
      if(length !==0){
      let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      if(!emailpattern.test(this.state.email)){
        return 'error';
      }
      }
    }
    
    return null
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();
 
    if(!err){
      this.setState({disabled:true})
      let formData = {
        email: this.state.email,
        orderID: this.state.orderID,
        lang: this.state.default_lang
      }
      this.props.orderStatus(formData);
    }
  }

  getValidationState() {
    if(this.state.phone){
      const length = this.state.phone.length;
      if(length !==0){
      let mobilepattern= new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
      if(!mobilepattern.test(this.state.phone)){
        return 'error';
       
      }
      }
    }
    
    return null
  }

 render() {
    return(
      <div> 
          <form onSubmit={this.handleSubmit}>            
            <div className="container">
                <Col md={6} mdOffset={3}>
	                <div className="panel margin-top">
	                  <header className="panel-heading text-center text-default">{languageConfig[this.state.default_lang].check_order_status}</header>
	                  <div className="panel-body">
	                    {this.state.showAlert && this.state.alertMessage !=='' &&        
	                      <div className="col-lg-12">
	                        <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
	                          <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
	                        </Alert>
	                      </div>
	                    }
	                    <Row>
	                      <p className="text-center">{languageConfig[this.state.default_lang].tract_on_order}</p>
	                      <Col md={12} xs={12}>
	                        <FormGroup>
	                          <ControlLabel>{languageConfig[this.state.default_lang].email_address}</ControlLabel>
	                          <FormControl
	                            type="text"
	                            value={this.state.email}
	                            placeholder={languageConfig[this.state.default_lang].email_address}
	                            onChange={this.handleChange}
	                            style={{borderColor:this.state.emailError}}
	                            name="email"
	                            autoComplete="off"
	                          />
	                        </FormGroup>
	                      </Col>
	                      <Col md={12} xs={12}>
	                        <FormGroup>
	                          <ControlLabel>{languageConfig[this.state.default_lang].order_number}:</ControlLabel>
	                          <FormControl
	                            type="text"
	                            value={this.state.orderID}
	                            placeholder={languageConfig[this.state.default_lang].order_number}
	                            onChange={this.handleChange}
	                            style={{borderColor:this.state.orderIDError}}
	                            name="orderID"
	                            autoComplete="off"
	                          />
	                        </FormGroup>
	                      </Col>
	                    </Row> 
	                    <Row>
		                  <Col md={12} xs={12}>
		                    <Button 
                          bsStyle="success" 
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'order') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'order'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff}
                          type="submit" 
                          disabled={this.state.disabled}
                        >
                          {languageConfig[this.state.default_lang].check_order_status}
                        </Button>
		                  </Col>
		                </Row>
		                {(this.state.orderList) && 
		                	<Row>
		                  		<Col md={12} xs={12}>
		                  		<Table striped bordered condensed hover className="margin-top">
			                    <thead>
			                      <tr>
			                        <th>{languageConfig[this.state.default_lang].order_id}</th>
			                        <th>{languageConfig[this.state.default_lang].voucher_number}</th>
                              <th>{languageConfig[this.state.default_lang].tracking_number}</th>
			                        <th>{languageConfig[this.state.default_lang].title}</th>
			                        <th>{languageConfig[this.state.default_lang].action}</th>
			                      </tr>
			                    </thead>
			                    <tbody>
			                        { (this.state.orderList.length > 0) ?
			                        	this.state.orderList.map((order, index) => 
			                    	<tr key={index}>
			                    		<td>{order.orderID}</td>
			                    		<td>{(order.proposalType != 10) ? order.voucherNumber : ' - ' }</td>
                              <td>{(order.shippingEmail == 1) ? order.trackingNumber : ' - ' }</td>
			                    		<td>{order.dealTitle}</td>
			                    		<td>{(order.proposalType != 10) ?
			                    			<Button
				                                onClick={() =>
				                                  this.context.router.history.push(`/voucher/${order.voucherID}`)
				                                }
				                            >
				                                <i className="glyphicon glyphicon-print" /> {languageConfig[this.state.default_lang].print}
				                            </Button>
                                : ' - ' }    
			                    		</td>
			                    	</tr>
			                    	)
			                        :
			                        <tr>
			                        	<td colSpan="4">{languageConfig[this.state.default_lang].data_not_found}</td>
			                        </tr>
			                    	}
			                    </tbody>
			                    </Table>
		                  		</Col>
		                	</Row>
		                }
	                  </div>
	                </div>
                </Col>
            </div>
          </form>
      </div>
    );
  }
}


OrderStatus.propTypes = {
 orderStatus: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  ordertracking: state.frontReducer.ordertracking,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
})



export default compose(
  connect(mapStateToProps,{orderStatus, renderAlert, clearAlert})
)(OrderStatus);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/OrderStatus.js